import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import "../index.css";
import "./index.css";
import TopMenu from "../Layout/TopMenu";
import MenuDesktop from "../Layout/MenuDesktop";
import Footer from "../Layout/Footer";
import { MDBRow, MDBCol } from "mdbreact";
import { IoSearch } from "react-icons/io5";
import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
} from "react-icons/ri";
import NavBar from "../Layout/NavBar";
import mixpanel from "mixpanel-browser";
import { HiLightningBolt, HiSortAscending } from "react-icons/hi";

import { firebase } from "../../../firebase/config";
import { TiTick } from "react-icons/ti";
import VisibilitySensor from "react-visibility-sensor";
import Scroll from "react-scroll";

class Intro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      querySellers: [],
    };
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  openModal = () => {
    this.setState({ signUp: true, isNavbar: false });
  };

  componentDidMount() {
    firebase
      .firestore()
      .collection("sellers")
      .orderBy("level", "desc")
      .limit(6)
      .get()
      .then((querySnapshot) => {
        let empty = [];
        querySnapshot.forEach((doc) => {
          empty.push(doc.data());
        });
        this.setState({ sellers: empty, querySellers: empty });
      });
  }

  render() {
    console.log(this.props.version);
    return (
      <>
        <MDBCol
          className="backy26"
          style={{
            width: "100vw",
            overflowX: "hidden",
            color: "white",
          }}
          size="12"
        >
          <MDBRow className="HeroSection">
            <MenuDesktop color="light" />
            <MDBCol size="12">
              <MDBRow style={{ paddingBottom: "5vh" }}>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      fontSize: 13,
                      marginTop: 40,
                      textAlign: "center",
                      color: "#FF0000",

                      opacity: 1,
                    }}
                  >
                    OUR MISSION
                  </p>
                </MDBCol>
                <MDBCol
                  style={{ marginTop: -30 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p style={{ color: "white" }} className="HeroHeading">
                    We're on a mission to help
                    <br />
                    creators and platforms grow
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{ width: "50%", color: "white" }}
                    className="HeroSubHeading"
                  >
                    We believe in empowering creators like your. By making it
                    cheap and easy to localise your content, we can help you
                    grow your audience faster. Chat with us today and see if we
                    can help.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <a
                    href=""
                    target="_blank"
                    className="d-flex justify-content-center"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex HeroButton lightButton justify-content-center"
                      style={{
                        backgroundColor: "#FF0000",
                        borderRadius: 200,
                        paddingTop: 13,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 17,
                        width: 170,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      Book a Demo
                    </div>
                  </a>
                </MDBCol>
                <MDBCol
                  style={{ marginTop: 9 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "white",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{" "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        color: "#FF0000",
                        textDecoration: "underline",
                      }}
                    >
                      {"  "}
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>

          <MDBRow
            style={{
              paddingBottom: "5vh",
              backgroundColor: "#F5F5F5",
              color: "black",
              width: "100vw",
              paddingLeft: "30%",
            }}
          >
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "#FF0000",
                  fontSize: 13,
                  marginTop: 90,
                  opacity: 1,
                }}
              >
                OUR STORY
              </p>
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSExtraBold",
                  fontSize: 29,
                  marginTop: -5,
                  lineHeight: 1.3,
                  width: "100%",
                }}
              >
                It all started in 2023...
              </p>
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "black",
                  opacity: 0.7,
                  fontSize: 16,
                  width: "60%",
                  marginTop: 0,
                  opacity: 0.7,
                }}
              >
                Our journey with YouDub began when we encountered the challenges
                of dubbing content for YouTube channels. We realized the
                time-consuming and labor-intensive nature of manual dubbing
                processes, which hindered content creators from reaching broader
                international audiences. To address this pain point, we
                developed YouDub, a cutting-edge platform for automated dubbing.
                <br />
                <br />
                YouDub revolutionizes the dubbing process by leveraging advanced
                AI technology. Our platform analyzes the audio content of
                YouTube videos, transcribes it, and generates accurate
                translations in real-time. These translations are then
                synchronized with the original video, resulting in high-quality
                dubbed versions that resonate with diverse language-speaking
                audiences.
                <br />
                <br />
                Content creators using YouDub gain several benefits. Firstly, it
                eliminates the need for manual translation and recording, saving
                substantial time and resources. Secondly, YouDub provides an
                opportunity to expand viewership and monetization potential by
                catering to international markets. By automatically dubbing
                their videos into different languages, content creators can
                engage a global audience and increase their YouTube channel's
                growth.
                <br />
                <br />
                YouDub supports multiple languages and accents, ensuring
                localized and authentic dubbing experiences. Our platform
                continually improves its accuracy and quality through machine
                learning algorithms and user feedback. You can rely on YouDub to
                deliver accurate and professional dubbing results that align
                with your channel's objectives.
                <br />
                <br />
                To get started with YouDub, sign up for a trial period and
                experience the capabilities of our platform. We offer flexible
                pricing plans tailored to the volume and duration of videos you
                process. Our dedicated support team is available to assist you
                throughout the onboarding process, ensuring a smooth integration
                into your workflow.
              </p>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <div
              className="pattern2"
              style={{
                height: 400,
                width: "100vw",
                backgroundRepeat: "repeat",
              }}
            >
              <MDBRow>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSExtraBold",
                      fontSize: 29,
                      color: "black",
                      marginTop: 100,
                      lineHeight: 1.3,
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Excited to join our mission?
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      opacity: 0.7,
                      fontSize: 16,
                      width: "30%",
                      marginTop: 0,
                      textAlign: "center",
                      opacity: 0.7,
                    }}
                  >
                    We're assembling a team of wonderful people that love
                    solving hard problems and working together.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <NavLink
                    to="/careers"
                    exact
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex HeroButton lightButton justify-content-center"
                      style={{
                        backgroundColor: "#FF0000",
                        borderRadius: 200,
                        paddingTop: 10,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 17,
                        width: 190,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      See open roles
                    </div>
                  </NavLink>
                </MDBCol>
                <MDBCol
                  style={{ marginTop: 9 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{" "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        textDecoration: "underline",
                        color: "#FF0000",
                      }}
                    >
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBRow>
        </MDBCol>
        <div className="HeroSection">
          <Footer />
        </div>
      </>
    );
  }
}

export default withRouter(Intro);
